
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manual/register_and_login",
      function () {
        return require("private-next-pages/manual/register_and_login.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manual/register_and_login"])
      });
    }
  